import React from 'react';
import Cookies from 'js-cookie';
import { makeRequest } from "../../utils/httpRequest";
import Config from "../../core/config";
import {formatDateStringToString} from "../../utils/utils";
import { usePermission } from "../../core/PermissionContext";
import { UserPermission } from "../../utils/utils";

const apiUrl = Config.apiUrl;

const PendingReceivables = ({ overdueReceivables, pendingReceivables = [] }) => {
    const { hasUserPermission } = usePermission();

    if (
        (!overdueReceivables || overdueReceivables.length === 0) &&
        (!pendingReceivables || pendingReceivables.length === 0)
    ) {
        return null;
    }

    const handlePayment = (id) => {
        const url = `${apiUrl}/api/mercadopago/create-preference/${id}`;
        makeRequest(url, 'POST', { 'Useruuid': Cookies.get('userUUID') })
            .then((response) => {
                const preferenceId = response.preferenceId;
                window.location.href = `https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${preferenceId}`;
            })
            .catch((error) => {
                console.error('Erro ao criar preferência de pagamento:', error);
            });
    };

    return (
        <div>
            {overdueReceivables?.length > 0 && (
                <ReceivableTable receivables={overdueReceivables} onPay={handlePayment} />
            )}

            {pendingReceivables?.length > 0 && (
                <ReceivableTable receivables={pendingReceivables} onPay={handlePayment} />
            )}
        </div>
    );
};

// 🔧 Componente auxiliar para desenhar a tabela
const ReceivableTable = ({ receivables, onPay }) => {
    return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
            <tr>
                <th>Descrição</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {receivables.map((p) => (
                <tr key={p.id}>
                    <td style={{width: '40%'}}>{p.description || '-'}</td>
                    <td style={{width: '20%'}}>{formatDateStringToString(p.dueDate)}</td>
                    <td style={{textAlign: 'right', width: '20%'}}>
                        R$ {p.value.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                    </td>
                    <td style={{textAlign:'center', width: '20%'}}>
                        {p.mercadoPago === true && (
                            <button onClick={() => onPay(p.id)}>Pagar</button>
                        )}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default PendingReceivables;
